export const LEAD_STATUSES = [
  "new",
  "routed",
  "whatsapp_opened",
  "contacted",
  "no_response",
  "test_drive_scheduled",
  "negotiating",
  "sold",
  "lost",
  "bad_lead",
  "archived",
];

export const STATUS_LABELS = {
  new: "Nuevo",
  routed: "Enrutado",
  whatsapp_opened: "WhatsApp abierto",
  contacted: "Contactado",
  no_response: "Sin respuesta",
  test_drive_scheduled: "Test drive agendado",
  negotiating: "Negociando",
  sold: "Vendido",
  lost: "Perdido",
  bad_lead: "Mala calidad",
  archived: "Archivado",
};

export const TEMPERATURE_LABELS = {
  alta_intencion: "Alta intención",
  buena_oportunidad: "Buena oportunidad",
  explorando_opciones: "Explorando opciones",
  investigacion_inicial: "Investigación inicial",
};

export const LEAD_TYPE_LABELS = {
  listing_inquiry: "Consulta vehículo",
  quiz_request: "Solicitud quiz",
  recommendation_inquiry: "Recomendación",
  dealer_contact: "Contacto concesionario",
  financing_interest: "Financiación",
  test_drive_request: "Test drive",
  video_request: "Video",
  price_request: "Precio",
  availability_request: "Disponibilidad",
};

export const OUTCOME_OPTIONS = [
  { value: "not_set", label: "Sin definir" },
  { value: "contacted", label: "Contactado" },
  { value: "no_response", label: "Sin respuesta" },
  { value: "test_drive_scheduled", label: "Test drive agendado" },
  { value: "negotiating", label: "Negociando" },
  { value: "sold", label: "Vendido" },
  { value: "lost_price", label: "Perdido — precio" },
  { value: "lost_financing", label: "Perdido — financiación" },
  { value: "lost_vehicle_unavailable", label: "Perdido — vehículo no disponible" },
  { value: "lost_buyer_not_ready", label: "Perdido — comprador no listo" },
  { value: "bad_contact_info", label: "Datos incorrectos" },
  { value: "duplicate_lead", label: "Duplicado" },
  { value: "spam_or_fake", label: "Spam o falso" },
  { value: "other", label: "Otro" },
];

export const QUALITY_OPTIONS = [
  { value: "excellent", label: "Excelente" },
  { value: "good", label: "Buena" },
  { value: "okay", label: "Regular" },
  { value: "poor", label: "Mala" },
  { value: "bad", label: "Muy mala" },
];

export const QUALITY_TAG_OPTIONS = [
  { value: "serious_buyer", label: "Comprador serio" },
  { value: "correct_budget", label: "Presupuesto correcto" },
  { value: "ready_to_buy", label: "Listo para comprar" },
  { value: "good_contact_info", label: "Buen contacto" },
  { value: "wrong_budget", label: "Presupuesto incorrecto" },
  { value: "did_not_respond", label: "No respondió" },
  { value: "bad_phone_number", label: "Teléfono incorrecto" },
  { value: "vehicle_unavailable", label: "Vehículo no disponible" },
  { value: "too_far_away", label: "Muy lejos" },
  { value: "not_interested", label: "No interesado" },
  { value: "duplicate", label: "Duplicado" },
  { value: "spam", label: "Spam" },
];

export const QUICK_STATUS_ACTIONS = [
  { action: "contacted", label: "Contactado" },
  { action: "no_response", label: "Sin respuesta" },
  { action: "test_drive_scheduled", label: "Test drive" },
  { action: "negotiating", label: "Negociando" },
  { action: "sold", label: "Vendido" },
  { action: "lost", label: "Perdido" },
  { action: "bad_lead", label: "Mala calidad" },
  { action: "archived", label: "Archivar" },
];

export const SORT_OPTIONS = [
  { value: "newest", label: "Más recientes" },
  { value: "oldest", label: "Más antiguos" },
  { value: "score_desc", label: "Mayor puntaje" },
  { value: "updated_desc", label: "Actualizados recientemente" },
  { value: "timeline_urgent", label: "Timeline más urgente" },
];

export function formatLeadStatus(status) {
  return STATUS_LABELS[status] || status || "—";
}

export function formatLeadTemperature(value) {
  return TEMPERATURE_LABELS[value] || value || "—";
}

export function formatLeadType(type) {
  return LEAD_TYPE_LABELS[type] || type || "—";
}

export function formatCop(value) {
  if (value == null) return "—";
  return new Intl.NumberFormat("es-CO", {
    style: "currency",
    currency: "COP",
    maximumFractionDigits: 0,
  }).format(value);
}

export function trackDealerLeadEvent(eventType, metadata = {}) {
  if (process.env.NODE_ENV === "development") {
    // eslint-disable-next-line no-console
    console.debug("[dealer-lead-event]", eventType, metadata);
  }
}

export function statusBadgeClass(status) {
  if (status === "new" || status === "routed") return "lead-badge--new";
  if (status === "sold") return "lead-badge--sold";
  if (status === "lost" || status === "bad_lead") return "lead-badge--lost";
  if (status === "archived") return "lead-badge--archived";
  if (status === "negotiating" || status === "test_drive_scheduled") return "lead-badge--active";
  return "lead-badge--default";
}
